import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import GuideArticleView from '../components/GuideArticleView';
import { guidesAPI } from '../services/api';
import { appUrl } from '../utils/appPaths';
import { deriveGuideSeoDescription, deriveGuideSeoKeywords, usePageSeo } from '../utils/seo';

const LoadingState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 340px;
  color: #64748b;
  font-size: 1.1rem;
`;

const ErrorState = styled.div`
  width: min(760px, calc(100% - (var(--site-gutter) * 2)));
  margin: 0 auto;
  padding: 40px 24px;
  margin-top: 32px;
  border-radius: 20px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
  text-align: center;
`;

const GuideArticle = () => {
  const { slug } = useParams();
  const { isAuthenticated } = useAuth();
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const seoTitle = guide?.title ? `${guide.title} | MicroPinouts Guides` : 'Guides | MicroPinouts';
  const seoDescription = deriveGuideSeoDescription(guide);
  const seoKeywords = deriveGuideSeoKeywords(guide);

  usePageSeo({
    title: seoTitle,
    description: seoDescription,
    keywords: seoKeywords,
    canonicalUrl: guide?.slug ? appUrl(`/guides/${guide.slug}`) : '',
  });

  useEffect(() => {
    const fetchGuide = async () => {
      try {
        setLoading(true);
        const response = await guidesAPI.getBySlug(slug);
        setGuide(response.data || null);
        setError('');
      } catch (fetchError) {
        console.error('Failed to load guide:', fetchError);
        setError('Guide not found.');
      } finally {
        setLoading(false);
      }
    };

    fetchGuide();
  }, [slug]);

  if (loading) {
    return <LoadingState>Loading guide...</LoadingState>;
  }

  if (error || !guide) {
    return <ErrorState>{error || 'Guide not found.'}</ErrorState>;
  }

  return (
    <GuideArticleView
      guide={guide}
      showEditButton={isAuthenticated && Boolean(guide?.id)}
      editTarget={guide?.id ? `/admin?tab=guides&editArticle=${guide.id}` : ''}
    />
  );
};

export default GuideArticle;
